import { ClientRegistrationRequestData, ClientRegistrationDataResponse } from '../types';
import FetchInstance from './FetchInstance';

export const getClientRegistrationData = async (): Promise<ClientRegistrationDataResponse> => {
    // return Promise.resolve(mock);
    const res = await FetchInstance.fetchWithAuthToken('/client-registration-data', {
        method: 'GET',
    });

    const data = await res.json();
    return data;
};

export const registerClient = async (body: ClientRegistrationRequestData): Promise<void> => {
    const res = await FetchInstance.fetchWithAuthToken('/client-registration', {
        method: 'PUT',
        body: JSON.stringify(body),
    });

    const data = await res.json();
    return data;
};
